import { useEffect, useCallback } from "react";

import {
    Box,
    CircularProgress,
    Grid,
    Typography,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { t } from "i18next";
import BasicDialog from "../../../../components/base/BasicDialog";
import { useToasts } from "../../../../hooks/useToasts";
import toast from "react-hot-toast";

import { useAdditionalPhonesForCompanyId, useUpdateAdditialPhonesForCompanyId } from "../../../../services/customersService";
import { useAdditionalPhonesForPersonId, useUpdateAdditialPhonesForPersonId } from "../../../../services/customersService";
import { SnackbarSuccess } from "../../../../components/base/SnackbarAlert/SnackbarSuccess";

import PhoneRecord from "./PhoneRecord";

import { isEmptyObject, isEmptyArray } from "../../../../helpers/methods";

const emptyObjectsList = [{}];


import { useForm } from "../../../../hooks/useForm";


export function AdditionalPhonesDialog(props) {
    const { personId, companyId } = props;
    
    const { data: phonesData, isLoading, isFetching, refetch } = (
        props.formValue 
            ? {data: props.formValue, isLoading: false, isFetching: false} :
               companyId ? useAdditionalPhonesForCompanyId(companyId)
                         : useAdditionalPhonesForPersonId(personId)
    )

    const {
    formValue,
    setFormValue,
    onChangeInArrayForm,
  } = useForm();

    const title = t("clients.ClientPassportDialog.additional_phones")

    const { onFormErrors, onServerError } = useToasts();

    const { mutate: updateAdditionalPhones, isPending } = 
        companyId ?
            useUpdateAdditialPhonesForCompanyId(
                companyId,
                {
                    onSuccess: () => {
                        toast.custom(
                            () => <SnackbarSuccess message={t("successfullyEdited")} />,
                            {
                                position: "bottom-right",
                            },
                        );
                    },
                    onError: (error) => {
                        onServerError(error);
                    },
                }
            ) 
        :
            useUpdateAdditialPhonesForPersonId(
                personId,
                {
                    onSuccess: () => {
                        toast.custom(
                            () => <SnackbarSuccess message={t("successfullyEdited")} />,
                            {
                                position: "bottom-right",
                            },
                        );
                    },
                    onError: (error) => {
                        onServerError(error);
                    },
                }
            );


    // Update form values when phone data is loaded
    useEffect(() => {
        if (isLoading) {
            return
        }
        setFormValue(!phonesData || isEmptyArray(phonesData) ? emptyObjectsList : phonesData)

    }, [isLoading]);

    const handleDelete = useCallback((index) => {
        setFormValue((prev) => {
        let newFormValue = [...prev];
        if (newFormValue.length !== 1) {
            newFormValue.splice(index, 1);
        } else {
            newFormValue.splice(index, 1, {});
        }

        return newFormValue;
        });
    }, []);

    const handleAdd = useCallback(() => {
        setFormValue((prev) => [...prev, {}]);
    }, []);

    const handleChangeInArrayForm = useCallback((...inputProps) => {
        onChangeInArrayForm(...inputProps);
    }, []);

    const prepareDataToSend = () => {
        return formValue.filter(phoneData=> !isEmptyObject(phoneData) && phoneData.phone_number).map(phoneData=>phoneData.phone_number)
    }

    const handleSubmit = () => {
        if (props.onSetFormValue) {
            props.onSetFormValue(prepareDataToSend())
            props.onClose()
            return
        }
        updateAdditionalPhones(prepareDataToSend())
    };

    const formIsValid = () => {
        const phoneRegex = /^\+48\s?\d{3}\s?\d{3}\s?\d{3}$/;
        return prepareDataToSend().every(phoneNumber => phoneRegex.test(phoneNumber))
    }

    if (isLoading || isFetching || !formValue) {
        return (
            <BasicDialog
                open={props.open}
                onClose={props.onClose}
                titleAlign={"center"}
                contentAlign={"center"}
                title="Loading..."
                maxWidth={"xs"}
                showDialogActions
                alwaysFullScreen={false}
            >
                <Box display="flex" justifyContent="center" p={4}>
                    <CircularProgress />
                </Box>
            </BasicDialog>
        );
    }
    return (
        <BasicDialog
            open={props.open}
            onClose={props.onClose}
            titleAlign={"center"}
            contentAlign={"center"}
            showTitle={false}
            title={title}
            maxWidth={"xs"}
            showDialogActions
            showTopFullScreenButton={false}
            alwaysFullScreen={false}
            contentSx={{ backgroundColor: "#f5f5f5" }}
            headerComponent={
                <Grid
                    container
                    direction={"row"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    sx={{ p: 2, backgroundColor: "#f5f5f5" }}
                    gap={3}
                >
                    <Typography variant={"h4"} sx={{ fontSize: "2rem", ontWeight: "bold" }}>
                        {title}
                    </Typography>
                </Grid>
            }
            
        >
            <Grid container  rowSpacing={1} columnSpacing={1} alignItems={"flex-start"}>
            <Grid item xs={12} container rowSpacing={2}>
            {formValue.map((phoneData, index) => (
                <PhoneRecord
                    key={index}
                    readOnly={props.readOnly}
                    index={index}
                    showAddButton={!props.readOnly && index === 0}
                    phoneNumber={phoneData.phone_number}
                    onAdd={handleAdd}
                    onDelete={handleDelete}
                    onChange={handleChangeInArrayForm}
                />))}
            </Grid>    
                {!props.readOnly && <Grid item xs={12}>
                    <LoadingButton
                        loading={isFetching || isPending}
                        disabled={!formIsValid()}
                        variant="contained"
                        color="primary"
                        sx={{ mt: 2 }}
                        onClick={handleSubmit}
                        fullWidth
                    >
                        {t("clients.passportDialogCompany.saveChanges")}
                    </LoadingButton>
                </Grid>}
            </Grid>
        </BasicDialog>
    );
}
